module.exports = __webpack_public_path__ + "media/images/professional-bc1d1e9bf1e4d4e4cbd57c7da5675800.jpeg";